(function () {
	function swiperInit() {
		const mainProductSection = document.querySelector(".main-product-section");
		window.__mainProductDifferentGallery = mainProductSection?.dataset?.mainProductDifferentGallery === "true";

		subSliderInit(true);
		sliderInit(true);
		popupSliderInit(true);

		if (window.__mainProductDifferentGallery) {
			subSliderInit(true, ".js-media-mobile-list", ".js-media-mobile-sublist");
			sliderInit(true, ".js-media-mobile-list", ".js-media-mobile-sublist");
		}
	}

	// This file is loaded from both the main-product.liquid and featured-product.liquid files,
	// so listeners and the first initialization must only run once per page.
	if (window.isSwiperInit) return;
	window.isSwiperInit = true;

	document.addEventListener("shopify:section:load", function (e) {
		const target = e.target;
		if (target && target.querySelector && !target.querySelector(".js-media-list, .js-media-mobile-list")) return;
		swiperInit();
	});

	swiperInit();
})();
